import { AssciCode } from '@/common/constant'
import ExerciseStoreAPI from '@/apis/business/teacher/exercise-store-api.js'
import MISAStoreAPI from '@/apis/business/MISAStore/exercise-store-api.js'
import FileAPI from '@/apis/business/common/file-api.js'
import cloneDeep from 'lodash/cloneDeep'
import i18n from '@/i18n'
import commonFn from '@/common/common-fn.ts'

import Enumeration from '@/common/enumeration.js'
import {
  validateContentQuestion,
  validateContentAnswer,
  validateCorrectAnswer,
  convertExercise,
  handleBeforeSave,
  handleMappingAnswer
} from '@/views/pages/teacher/storage/create/common/common.js'
import { nextTick } from 'vue'
import { sessionStorageKeys } from '@/common/storage-keys.ts'
import { sessionStorage } from '@/utils/storage'
const NumberAnswerDefault = 4
const COEFFICIENT_DEFAULT = 1

const $t = i18n?.global?.t

export default {
  namespaced: true,

  state: {
    exerciseStore: {
      // Id: null,
      // Type: Enumeration.ExerciseType.Compose,
      // SubjectID: null,
      // SubjectCode: null,
      // SubjectName: null,
      // GradeID: null,
      // GradeName: null,
      // TopicIDs: [],
      // Title: null,
      // Tags: [],
      // Owner: null,
      // CoverImage: {},
      // QtyQuestion: 0,
      // Questions: [
      //   // {
      //   //   Type: Enumeration.QuestionType.Select,
      //   //   Content: null,
      //   //   Attachments: [],
      //   //   Owner: null,
      //   //   Hint: null,
      //   //   Answers: [],
      //   //   // MappingAnswer: {
      //   //   //   CorrectAnswer: null,
      //   //   //   AnswerColumnName: null
      //   //   // },
      //   //   ParentID: null,
      //   //   SortOrder: 0
      //   //   // NumberNo: null
      //   // }
      // ],
      // // ParentQuestions: [
      // //   // {
      // //   //   Content: null,
      // //   //   Attachments: [],
      // //   //   SortOrder: 0,
      // //   //   NumberNo: null,
      // //   //   IsSeamless: true
      // //   // }
      // // ],
      // QuestionAttachment: null,
      // AnswerAttachment: null,
      // AnswerType: Enumeration.AnswerType.Compose,
      // Status: null
    },
    exerciseStoreDefault: null,
    fileManager: [],
    questionPreviewIndex: 0,
    addQuestionType: 0,
    copyQuestionStatus: false,
    deleteQuestionStatus: false,

    questionAttachmentIndex: 0,
    questionIndex: 0,
    question: null,
    addOnPreviewQuestion: null,
    summaryResults: null,
    isShowMask: false,
    errorQuestions: [],
    selectedQuestion: 0,
    isReadyComponent: true,
    currentParentID: null,
    currentQuestion: {
      Type: 0, // Loại câu hỏi
      Content: '', // Nội dung câu hỏi
      Attachments: [], // Đính kèm
      Owner: null, // Người sở hữu
      Hint: '', // Gọi ý
      Answers: [], // Danh sách câu trả lời
      SortOrder: null,
      Level: Enumeration.QuestionLevel?.Normal,
      Coefficient: COEFFICIENT_DEFAULT,
      NumberNo: null,
      Time: null,
      ChildrenQuestions: [],
      MappingAnswer: {},
      ParentQuestion: {}
    },
    composeDialogMode: Enumeration.EditMode.None,
    exerciseStoreImport: [],
    extracResult: [],
    waringRemoveChildrenQuestion: false,
    warningRemoveAnswer: false,
    // PBac
    submitExercise: [], // Dữ liệu bài làm clone để giáo viên làm thử
    exerciseThemeIndex: 0, // theme mặc định giao diện làm thử bài tập
    isNotDoneExercise: false, // đang làm bài dở hay không
    indexQuestion: 0, // Câu hỏi đang focus phần làm thử,
    isComplete: false,
    isResetDraw: false,
    isParent: false,
    onSearch: false,
    filesUploadGoogleImage: [],

    isAnswerGoogleImage: false,
    isContentQuestion: false,

    isSharingExercise: false,
    isShowMessageBoxWarningEditExercise: false,
    callBack: null,

    questionAttachments: [], // list file đề bài đính kèm
    questionAttachmentPreview: {} // file đề bài preview
  },

  getters: {
    newQuestion (state) {
      return {
        Type: 0, // Loại câu hỏi
        Content: '', // Nội dung câu hỏi
        Attachments: [], // Đính kèm
        Owner: null, // Người sở hữu
        Hint: '', // Gọi ý
        Answers: [], // Danh sách câu trả lời
        ParentQuestion: {},
        ChildrenQuestions: [],
        MappingAnswer: {},
        SortOrder: null,
        Level: Enumeration.QuestionLevel?.Normal,
        Coefficient: COEFFICIENT_DEFAULT,
        NumberNo: null
      }
    },

    newAnswer (state) {
      return {
        Correct: false, // Đúng|Sai
        Content: '', // Nội dung
        Image: null, // Ảnh đính kèm
        SortOrder: 0
      }
    },

    getExerciseStore (state) {
      return state.exerciseStore
    },

    questionFocus (state) {
      return state.questionPreviewIndex < state.exerciseStore?.Questions?.length
        ? state.exerciseStore?.Questions[state.questionPreviewIndex]
        : {}
    },

    /**
     * Tổng số câu hỏi
     * @param {*} state
     */
    totalQuestions (state) {
      return state.exerciseStore?.Questions?.length
    },

    /** Danh sách câu hỏi
     *  validate câu hỏi
     * @param {*} state
     * @returns
     */
    questions (state) {
      const INVALID_TYPE = Enumeration.QuestionInvalidType
      if (
        state.exerciseStore.Questions?.length &&
        state.exerciseStore.Questions?.every((question) => !question.NumberNo)
      ) {
        state.exerciseStore.Questions.map((question) => {
          question.NumberNo = `${question.SortOrder}`

          return question
        })

        state.exerciseStore.ParentQuestions?.length &&
          state.exerciseStore.ParentQuestions?.map((parenQuesion) => {
            parenQuesion.NumberNo = `${$t('EnumResource.QuestionType.Group')}`
            parenQuesion.IsSeamless = true
            return parenQuesion
          })
      }
      let questions = convertExercise(state.exerciseStore)
      questions = questions?.map((question) => {
        question.invalids = []
        if (question.Type !== Enumeration.QuestionType.Group) {
          if (!validateCorrectAnswer(question)) {
            question.invalids.push(INVALID_TYPE.CorrectAnswer)
          }
          if (!validateContentAnswer(question)) {
            question.invalids.push(INVALID_TYPE.ContentAnswer)
          }
          if (!validateContentQuestion(question)) {
            question.invalids.push(INVALID_TYPE.ContentQuestion)
          }
        } else {
          question.ChildrenQuestions.map((childrenQuestion) => {
            childrenQuestion.invalids = []
            if (!validateCorrectAnswer(childrenQuestion)) {
              childrenQuestion.invalids.push(INVALID_TYPE.CorrectAnswer)
            }
            if (!validateContentAnswer(childrenQuestion)) {
              childrenQuestion.invalids.push(INVALID_TYPE.ContentAnswer)
            }
          })

          if (!validateContentQuestion(question.ParentQuestion)) {
            question.invalids.push(INVALID_TYPE.ContentGroupQuestion)
          }
        }
        return question
      })

      return questions || []
    },

    /**
     * Danh sách câu hỏi nhóm
     * @param {*} state
     * @returns
     */
    parentQuestionsFilter (state) {
      const questions = state.exerciseStore?.Questions
      let parentQuestions = []
      parentQuestions = questions?.map((question, index) => {
        return { question: question, index: index }
      })

      parentQuestions = parentQuestions?.filter((parentQuestion) => {
        return !!parentQuestion.question.ParentID
      })

      let parentQuestionsFilter = []
      state.exerciseStore?.ParentQuestions?.forEach((parentQuestion) => {
        let data = parentQuestions?.filter((element) => {
          return element.question.ParentID === parentQuestion.SortOrder
        })

        data = data?.map((item) => {
          return item.index
        })

        if (data.length > 1) parentQuestionsFilter?.push(data)
      })
      parentQuestionsFilter = parentQuestionsFilter?.sort((a, b) => {
        return a - b
      })

      // const parentID = questions[state.selectedQuestion - 1]?.ParentID
      // const data = questions.filter(question => {
      //   return question.ParentID === parentID
      // })

      return parentQuestionsFilter
    },

    /**
     * Chỉ số câu hỏi nhóm sựa vào câu hỏi đang focus
     * @param {*} state
     */
    parentQuestionsIndex (state) {
      const questions = state.exerciseStore?.Questions
      const parentID = questions[state.questionPreviewIndex]?.ParentID
      const dataIndexs = []

      questions.forEach((question, index) => {
        if (question.ParentID === parentID) dataIndexs.push(index)
      })

      return {
        startIndex: dataIndexs[0],
        endIndex: dataIndexs[dataIndexs.length - 1],
        dataIndexs: dataIndexs
      }
    },

    isHaveParentQuestion (state) {
      let result = false

      state.exerciseStore?.ParentQuestions.forEach((parentQuestion) => {
        const questionIndex = state.exerciseStore?.Questions.findIndex(
          (question) => {
            return question.ParentID === parentQuestion.SortOrder
          }
        )

        if (state.exerciseStore?.Questions[questionIndex + 1]?.ParentID) { result = true }
      })

      return result
    },

    parentQuestionSortOrder (state) {
      const DEFAULT_VALUE = -1
      const parentQuestions = state.exerciseStore?.ParentQuestions
      const sortOrders = []
      if (parentQuestions?.length) {
        parentQuestions.forEach((parentQuestion) => {
          sortOrders.push(parentQuestion.SortOrder)
        })
      }

      return sortOrders.length ? Math.max(...sortOrders) + 1 : DEFAULT_VALUE
    },

    isGroupQuestion (state) {
      return !!state.currentQuestion.ParentID
    },

    lastSortOrder (state) {
      let lastSortOrder = 1
      if (state.exerciseStore?.Questions?.length) {
        lastSortOrder =
          state.exerciseStore?.Questions[
            state.exerciseStore.Questions?.length - 1
          ]?.SortOrder + 1
      }

      return lastSortOrder
    },

    firstChildrenQuestionNumberNo (state) {
      let numberNo = -1

      const childrenQuestions = state.currentQuestion?.ChildrenQuestions
      const parentQuestion = state.currentQuestion?.ParentQuestion
      if (parentQuestion.IsSeamless) {
        if (childrenQuestions.length) {
          numberNo = parentQuestion.NumberNo?.slice(
            parentQuestion.NumberNo?.indexOf(' ') + 1
          )
        }
      } else {
        numberNo = childrenQuestions[0].NumberNo
      }

      return Number(numberNo)
    },

    lastParentQuestionSortOrder (state) {
      let lastSortOrder = 1
      if (state.exerciseStore?.ParentQuestions?.length) {
        lastSortOrder =
          state.exerciseStore?.ParentQuestions[
            state.exerciseStore.ParentQuestions?.length - 1
          ]?.SortOrder + 1
      }

      return lastSortOrder
    },

    lastChildrentQuestionSortOrder (state) {
      let lastSortOrder = 1
      if (state.currentQuestion?.ChildrenQuestions?.length) {
        lastSortOrder =
          state.currentQuestion?.ChildrenQuestions[
            state.currentQuestion?.ChildrenQuestions?.length - 1
          ]?.SortOrder + 1
      }

      return lastSortOrder
    },

    nextChildrentQuestionNumberNo (state) {
      let numberNo = null
      const childrenQuestions = state.currentQuestion?.ChildrenQuestions
      const parentQuestion = state.currentQuestion?.ParentQuestion

      if (parentQuestion.IsSeamless) {
        if (childrenQuestions.length) {
          numberNo = `${
            Number(childrenQuestions[childrenQuestions?.length - 1]?.NumberNo) +
            1
          }`
        }
      } else {
        numberNo = `${Number(
          parentQuestion.NumberNo?.slice(parentQuestion.NumberNo?.indexOf(' '))
        )}.${childrenQuestions?.length + 1}`
      }

      return numberNo
    },

    lastQuestion (state) {
      let lastQuestion = {}

      if (state.exerciseStore?.Questions?.length) {
        lastQuestion =
          state.exerciseStore?.Questions[
            state.exerciseStore?.Questions?.length - 1
          ]
      }
      return lastQuestion
    },

    lastQuestionNumberNo (state) {
      let numberNo = '1'

      const questions = state.exerciseStore.Questions
      const parentQuestions = state.exerciseStore.ParentQuestions
      if (questions?.length) {
        const lastQuestion = questions[questions?.length - 1]

        if (lastQuestion?.ParentID) {
          const lastParentQuestion = parentQuestions?.find(
            (element) => element.SortOrder === lastQuestion?.ParentID
          )

          if (lastParentQuestion?.IsSeamless) {
            numberNo = Number(lastQuestion.NumberNo) + 1
          } else {
            numberNo =
              Number(
                lastParentQuestion.NumberNo?.slice(
                  lastParentQuestion.NumberNo?.indexOf(' ') + 1
                )
              ) + 1
          }
        } else {
          numberNo = Number(lastQuestion.NumberNo) + 1
        }
      }

      return Number(numberNo)
    },

    currentGroupQuestionNumberNo (state) {
      const parentQuestion = state.currentQuestion?.ParentQuestion
      const childrenQuestions = state.currentQuestion?.ChildrenQuestions
      let numberNo = 1
      if (childrenQuestions?.length) {
        if (parentQuestion?.IsSeamless) {
          numberNo = `${childrenQuestions[0]?.NumberNo}`
        } else {
          numberNo = `${Number(
            parentQuestion.NumberNo?.slice(
              parentQuestion.NumberNo?.indexOf(' ') + 1
            )
          )}`
        }
      } else {
        numberNo = state.currentQuestion.NumberNo
      }

      return numberNo
    },

    waringRemoveChildrenQuestion (state) {
      return state.currentQuestion?.ChildrenQuestions?.length > 1
    }
  },

  mutations: {

    swapExerciseStore (state, params) {
      const DRAG_INDEX = params.oldIndex
      const DROP_INDEX = params.newIndex

      if (state.questionAttachmentIndex === DRAG_INDEX) {
        state.questionAttachmentIndex = DROP_INDEX
      } else {
        if (DRAG_INDEX > DROP_INDEX) {
          state.questionAttachmentIndex = state.questionAttachmentIndex + 1
        }
        if (DRAG_INDEX < DROP_INDEX) {
          state.questionAttachmentIndex = state.questionAttachmentIndex - 1
        }
      }

      // if (state.questionAttachmentIndex === DROP_INDEX) {

      // }
    },

    setQuestionAttachmentIndex (state, value) {
      state.questionAttachmentIndex = value
    },

    setQuestionAttachments (state, value) {
      state.questionAttachments = value
    },

    setQuestionAttachmentPreview (state, value) {
      state.questionAttachmentPreview = value
    },

    setCallBack (state, callBack) {
      state.callBack = callBack
    },

    setIsSharingExercise (state, value) {
      state.isSharingExercise = value
    },

    setIsShowPopupWaringingEditExercise (state, value) {
      state.isShowMessageBoxWarningEditExercise = value
    },

    setIsAnswerGoogleImage (state, param) {
      state.isAnswerGoogleImage = param
    },

    setFilesUploadGoogleImage (state, params) {
      state.filesUploadGoogleImage = params
    },

    setOnSearch (state, param) {
      state.onSearch = param
    },

    setIsParent (state, param) {
      state.isParent = param
    },

    clearFileManager (state) {
      state.fileManager = []
    },

    resetDraw (state) {
      state.isResetDraw = !state.isResetDraw
    },

    setIscomplete (state, value) {
      state.isComplete = value
    },

    setFileManager (state, fileManager) {
      state.fileManager = fileManager
    },

    addFileManager (state, file) {
      state.fileManager.push(file)
    },

    removeChildrenQuestion (state, index) {
      const childrenQuestions = state.currentQuestion?.ChildrenQuestions

      if (childrenQuestions?.length === 1) {
        state.waringRemoveChildrenQuestion = true
        return
      }

      const parentQuestion = state.currentQuestion?.ParentQuestion
      const currentChildrenQuestion = childrenQuestions[index]
      let numberNo = 1

      parentQuestion.IsSeamless
        ? (numberNo = Number(currentChildrenQuestion.NumberNo))
        : (numberNo = Number(
            parentQuestion.NumberNo?.slice(
              parentQuestion.NumberNo?.indexOf(' ')
            )
        ))

      const childrenQuestionFixed = []

      for (let i = 0; i < index; i++) {
        childrenQuestionFixed.push(childrenQuestions[i])
      }
      const questionHandles = childrenQuestions.filter(
        (question, i) => i > index
      )

      questionHandles.map((question, i) => {
        if (parentQuestion.IsSeamless) {
          question.NumberNo = `${numberNo + i}`
        } else {
          question.NumberNo = `${numberNo}.${index + i + 1}`
        }

        return question
      })

      state.currentQuestion.ChildrenQuestions = [
        ...childrenQuestionFixed,
        ...questionHandles
      ]
      if (
        state.questionPreviewIndex >= index &&
        state.questionPreviewIndex > 0
      ) {
        state.questionPreviewIndex--
      }
    },

    setWaringRemoveChildrenQuestion (state, value) {
      state.waringRemoveChildrenQuestion = value
    },

    setWarningRemoveAnswer (state, value) {
      state.warningRemoveAnswer = value
    },

    /**
     * @description hàm convert data từ file import vào question
     * @author BNDung
     * @param {*} state
     * @param {*} questions
     */
    convertQuestion (state, questions) {
      const $t = i18n?.global?.t
      state.exerciseStoreImport.ParentQuestions = []
      state.exerciseStoreImport.Questions = []
      const QuestionType = Enumeration.QuestionType
      state.extracResult = questions?.data[questions.data.length - 1]
      questions.data = questions?.data?.slice(0, -1)
      // reset sortOrder
      let numberNoCount = 1

      questions?.data?.map((x, i) => {
        let isSetNumberNo = false
        const keys = Object.keys(x)
        // const defaulSort = 1
        x.Answers = []

        if (!('Content' in x)) {
          x.Content = ''
        } else {
          x.Content = commonFn.convertTextToHtml(x.Content)
          x.Content = `<pre style="white-space: pre-wrap">${x?.Content}</pre>`
        }
        if (!('Attachments' in x)) {
          x.Attachments = []
        }

        // lấy ra số lượng đáp án để add vào answers
        /**
         * add đáp án Answer1, Answer2, Answer3, ... vào Answers thành 1 list
         * add cả lời giải vào
         */
        for (let index = 0; index < keys.length; index++) {
          if (keys[index].includes('CorrectAnswer')) {
            // lấy ra những câu đúng
            const correctAnswer = x[keys[index]].split('||')
            x.Answers.map((answer, index) => {
              if (correctAnswer.includes(answer?.SortOrder?.toString())) {
                answer.Correct = true
              }
            })
          } else if (keys[index].includes('Answer')) {
            const answer = {
              SortOrder: x?.Answers.length + 1,
              Content: x[keys[index]]?.trim(),
              Correct: false
            }
            delete x[keys[index]]
            x.Answers.push(answer)
          }
        }

        // convert type
        switch (x.Type) {
          case QuestionType.Select:
            // type = Enumeration.QuestionType.Select
            break
          case QuestionType.Yesorno:
            // type = Enumeration.QuestionType.Yesorno
            break
          case QuestionType.Fill:
            // type = Enumeration.QuestionType.Fill
            break
          case QuestionType.Essay:
            x.Answers.push({
              Correct: true,
              Image: null,
              SortOrder: 0,
              Content: x.Hint ? `<pre>${x?.Hint}</pre>` : ''
            })

            x.Hint = ''
            // type = Enumeration.QuestionType.Essay
            break
          case QuestionType.Group:
            // type = Enumeration.QuestionType.Group
            x.NumberNo = $t('Exercise.TheSentenceNumber', {
              number: numberNoCount
            })
            x.NumberNoIndex = numberNoCount
            numberNoCount++ // tăng số lượng number no
            isSetNumberNo = true // nếu câu hỏi cha đã set number no thì không cần thêm number no nữa
            x.IsSeamless = false
            state.exerciseStoreImport.ParentQuestions.push(x)
            return false

          default:
            break
        }
        /**
         * set number no nếu là câu bình thường
         */
        if (!('ParentID' in x) && !isSetNumberNo) {
          x.NumberNo = numberNoCount
          numberNoCount++
        }
        // x.Type = type
        state.exerciseStoreImport.Questions.push(x)
      })

      /**
       * sắp xếp thứ tự câu hỏi nhóm nếu câu 1 thì câu con sẽ là 1.1, 1.2 ...
       */
      let currentParent = 0
      let incre = 1

      for (
        let index = 0;
        index < state.exerciseStoreImport.Questions.length;
        index++
      ) {
        // ép kiểu của ParentID từ String sang Number
        if (state.exerciseStoreImport.Questions[index].ParentID) {
          state.exerciseStoreImport.Questions[index].ParentID = Number(
            state.exerciseStoreImport.Questions[index].ParentID
          )
        }
        /**
         * set lại sort order
         * */
        state.exerciseStoreImport.Questions[index].SortOrder = index + 1
        /**
         * nếu cùng câu hỏi cha thì tăng còn nếu qua câu tiếp theo thì reset lại biến tăng dần
         */
        if (
          currentParent === state.exerciseStoreImport.Questions[index].ParentID
        ) {
          incre++
        } else {
          incre = 1
        }
        if ('ParentID' in state.exerciseStoreImport.Questions[index]) {
          const parent = state.exerciseStoreImport.ParentQuestions.find(
            (parent) => {
              return (
                parent.SortOrder ===
                state.exerciseStoreImport.Questions[index].ParentID
              )
            }
          )
          state.exerciseStoreImport.Questions[
            index
          ].NumberNo = `${parent?.NumberNoIndex}.${incre}`
        }
        currentParent = state.exerciseStoreImport.Questions[index].ParentID
      }
    },

    setSortOrder (state) {
      state.exerciseStore.Questions = state.exerciseStore.Questions?.map(
        (question, indexQuestion) => {
          question.SortOrder = indexQuestion + 1
          if (question.Type !== Enumeration.QuestionType.Pairing) {
            question.Answers?.map((answer, answerIndex) => {
              answer.SortOrder = answerIndex + 1

              return answer
            })
          }

          return question
        }
      )
    },

    resetNumberNo (state, questionIndex) {
      const questions = state.exerciseStore?.Questions
      const parentQuestions = state.exerciseStore?.ParentQuestions
      const questionLength = state.exerciseStore?.Questions?.length
      const questionsHandle = []
      let isPush = true

      for (let index = questionIndex; index < questionLength; index++) {
        const currentQuestion = questions[index]
        const currentParentQuesionID = currentQuestion.ParentID

        let numberNo = 1
        if (index > 0) {
          const lastQuestion = questions[index - 1]
          if (lastQuestion.ParentID) {
            const lastParentQuestion = parentQuestions?.find(
              (element) => element.SortOrder === lastQuestion.ParentID
            )

            lastParentQuestion.IsSeamless
              ? (numberNo = Number(lastQuestion.NumberNo) + 1)
              : (numberNo =
                  Number(
                    lastParentQuestion.NumberNo?.slice(
                      lastParentQuestion.NumberNo?.indexOf(' ') + 1
                    )
                  ) + 1)
          } else {
            numberNo = Number(lastQuestion.NumberNo) + 1
          }
        }

        if (currentParentQuesionID) {
          if (isPush) {
            const childrenQuestions = questions.filter(
              (element) => element.ParentID === currentParentQuesionID
            )
            const parentQuestion = parentQuestions?.find(
              (element) => element.SortOrder === currentParentQuesionID
            )

            if (parentQuestion.IsSeamless) {
              parentQuestion.NumberNo = $t('EnumResource.QuestionType.Group')
              childrenQuestions.map((element, i) => {
                element.NumberNo = `${numberNo + i}`
                return element
              })
            } else {
              parentQuestion.NumberNo = `${$t('Common.Sentence')} ${numberNo}`
              childrenQuestions.map((element, i) => {
                element.NumberNo = `${numberNo}.${i + 1}`
                return element
              })
            }

            questionsHandle.push(...childrenQuestions)
          }
          isPush = false

          if (index < questionLength - 1) {
            const nextQuestion = questions[index + 1]
            const nextParentQuestionID = nextQuestion.ParentID
            if (
              typeof nextParentQuestionID === 'number' &&
              nextParentQuestionID !== currentParentQuesionID
            ) {
              isPush = true
            }
          }
        } else {
          currentQuestion.NumberNo = `${numberNo}`
          questionsHandle.push(currentQuestion)
          isPush = true
        }
      }

      const questionFixed = questions.splice(0, questionIndex)
      state.exerciseStore.Questions = [...questionFixed, ...questionsHandle]
    },

    setCurrentParentID (state, parentID) {
      state.currentParentID = parentID
    },

    setCurrentQuestion (state, question) {
      state.currentQuestion = question
    },

    setComposeDialogMode (state, mode) {
      state.composeDialogMode = mode
    },

    /**
     * reset khi chọn cbb từ option câu hỏi nhóm sang câu hỏi loại khác
     * @author NTQuy
     * @param {*} state
     * @param {*} parentID
     */
    resetParentQuestions (state, parentID) {
      if (parentID) {
        const questions = state.exerciseStore.Questions
        const parentQuestionIndex =
          state.exerciseStore.ParentQuestions?.findIndex((parentQuestion) => {
            return parentQuestion.SortOrder === parentID
          })
        const firstParentQuestion = questions?.findIndex((question) => {
          return question.ParentID === parentID
        })

        const questionFilter = questions?.filter((question) => {
          return question.ParentID !== parentID
        })

        if (firstParentQuestion > -1) {
          firstParentQuestion < state.questionPreviewIndex
            ? (state.questionPreviewIndex = firstParentQuestion)
            : (state.questionPreviewIndex = firstParentQuestion - 1)
        }
        state.exerciseStore.Questions = questionFilter
        state.exerciseStore.ParentQuestions?.splice(parentQuestionIndex, 1)
      }
    },

    updateQuestion (state, questionIndex) {
      const parentID = state.currentQuestion.ParentID
      const sortOrder = state.currentQuestion.SortOrder

      if (parentID > 0) {
        /// find
        const questionsFilter = state.exerciseStore.Questions?.filter(
          (question) =>
            question.ParentID !== parentID && question.SortOrder !== sortOrder
        )
        const firstChildrenQuestion = questionIndex
        let parentQuestionsFilter =
          state.exerciseStore.ParentQuestions?.filter(
            (parentQuestion) => parentQuestion.SortOrder !== parentID
          )

        /// replace
        questionsFilter.splice(
          firstChildrenQuestion,
          0,
          ...state.currentQuestion.ChildrenQuestions
        )
        parentQuestionsFilter?.length
          ? parentQuestionsFilter.push(state.currentQuestion.ParentQuestion)
          : parentQuestionsFilter = [state.currentQuestion.ParentQuestion]

        /// assign
        state.exerciseStore.Questions = questionsFilter
        state.exerciseStore.ParentQuestions = parentQuestionsFilter
      } else {
        if (state.currentQuestion.ParentQuestion?.SortOrder) {
          const oldParentID = state.currentQuestion.ParentQuestion.SortOrder
          const questionsFilter = state.exerciseStore.Questions?.filter(
            (question) => question.ParentID !== oldParentID
          )

          state.currentQuestion.ChildrenQuestions = []
          state.currentQuestion.ParentQuestion = {}
          questionsFilter.splice(questionIndex, 0, state.currentQuestion)
          state.exerciseStore.Questions = questionsFilter
          state.exerciseStore.ParentQuestions =
            state.exerciseStore.ParentQuestions.filter(
              (element) => element.SortOrder !== oldParentID
            )
        } else {
          state.exerciseStore.Questions[questionIndex] = state.currentQuestion
        }
      }
    },

    /**
     * @description set tổng số câu đúng, sai, chưa làm
     * @param {} state
     * @param {*} params
     */
    setSummaryResults (state, param) {
      state.summaryResults = param
      // var questions = state?.exerciseStore?.Questions
      // state.summaryResults = {
      //   TotalCorrect: 0,
      //   TotalFalse: 0,
      //   TotalNotDone: 0
      // }

      // questions.map(item => {
      //   switch (item.Type) {
      //     case Enumeration.QuestionType.Yesorno:
      //       item.Answers.map((answer) => {
      //         var correct = item.CorrectAnswer.find(item => {
      //           return item.SortOrder === answer.SortOrder
      //         })
      //         if (correct && answer.Correct === true) { // học sinh trả lời
      //           if (correct.Correct === true) {
      //             // set màu xanh nếu câu trả lời đúng
      //             state.summaryResults.TotalCorrect += 1
      //           } else { // set màu đỏ nếu câu trả lời sai
      //             state.summaryResults.TotalFalse += 1
      //           }
      //         }
      //       })
      //       break
      //     case Enumeration.QuestionType.Select:
      //       var isCorrect = true
      //       var countAnswer = item.Answers.filter(x => x.Correct === true).length || 0
      //       if (countAnswer !== 0) {
      //         item.Answers.map((answer) => {
      //           var correct = item.CorrectAnswer.find(item => {
      //             return item.SortOrder === answer.SortOrder
      //           })
      //           if (correct && answer.Correct === true) { // giáo viên trả lời
      //             if (correct.Correct === false) {
      //             // set màu xanh nếu câu trả lời đúng
      //               isCorrect = false
      //               return false
      //             }
      //           }
      //         })
      //         if (isCorrect) {
      //           state.summaryResults.TotalCorrect += 1
      //         } else {
      //           state.summaryResults.TotalFalse += 1
      //         }
      //       }

      //       break
      //     case Enumeration.QuestionType.Fill:
      //       item.Answers.map(answer => {
      //         var correct = item.CorrectAnswer.find(item => { // lấy ra lời giải theo sort order
      //           return item.SortOrder === answer.SortOrder
      //         })
      //         if (correct) {
      //           const stringAnswer = answer?.Content?.toLowerCase()
      //           const listStringAnswer = correct?.Content?.toLocaleLowerCase()
      //           answer.numericalOrder = (String.fromCharCode(AssciCode.Upper[0] + answer.SortOrder)).toLowerCase() + '. '
      //           if (listStringAnswer?.includes(stringAnswer)) { // câu trả lời đúng
      //             state.summaryResults.TotalCorrect += 1
      //           } else { // câu trả lời sai
      //             state.summaryResults.TotalFalse += 1
      //           }
      //         }
      //       })
      //       break
      //     default:
      //       break
      //   }
      // })

      // state.summaryResults.TotalNotDone = questions.length - state.summaryResults.TotalCorrect - state.summaryResults.TotalFalse
    },

    /**
     * giữ nguyên trạng thái file soạn bài
     * @param {*} state
     * @param {*} exerciseStoreDefault
     */
    setExerciseStoreDefault (state, exerciseStoreDefault) {
      state.exerciseStoreDefault = exerciseStoreDefault
    },

    setExerciseStoreEdit (state, exerciseStore) {
      state.exerciseStore = null
      state.exerciseStore = state.exerciseStoreDefault

      if (exerciseStore) {
        state.exerciseStore = exerciseStore
      }
    },

    /**
     * Thay đổi state kiểm tra component có sẵn sàng để thực hiện các tác vụ hay không
     * @param {*} state
     * @param {*} isReady
     */
    setIsReadyComponent (state, isReady) {
      state.isReadyComponent = isReady
    },

    /**
     * setup dữ liệu để làm thử bài
     * @param {*} state
     * @param {*} exerciseStore
     */
    setExerciseStoreForTry (state, exerciseStore) {
      var lstCorrectAnswer = []

      state.exerciseStoreDefault = JSON.parse(
        JSON.stringify(exerciseStore || {})
      )

      // clone lstCorrectAnswer = correct
      exerciseStore?.Questions?.map((question, index) => {
        lstCorrectAnswer.push(question.Answers)
      })

      // clone Correct = CorrectAnswer
      state?.exerciseStoreDefault?.Questions.map((question, index) => {
        question.SortOrder = index + 1
        question.CorrectAnswer = null
        question.CorrectAnswer = JSON.parse(
          JSON.stringify(lstCorrectAnswer[index])
        )
      })

      // clear correct + content nếu là dạng fill
      state?.exerciseStoreDefault?.Questions.map((question) => {
        question.Answers.map((answer) => {
          answer.Correct = false
          if (question.Type === Enumeration.QuestionType.Fill) {
            answer.Content = ''
          }
        })
      })
    },

    /**
     * @author PVThang
     * @param {*} state
     * @param {object} newExerciseStore
     * @description set giá trị exerciseStore
     */
    setExerciseStore (state, newExerciseStore) {
      state.exerciseStore = newExerciseStore
    },

    /**
     * @description hàm set dữ liệu khi bấm vào sửa nhanh
     * @param {*} state
     * @param {*} question
     */
    setQuestionIndex (state, questionIndex) {
      state.questionIndex = questionIndex
    },

    /**
     * @description hàm set dữ liệu khi bấm vào sửa nhanh
     * @param {*} state
     * @param {*} question
     */
    setQuestion (state, question) {
      state.question = JSON.parse(JSON.stringify(question))
    },

    /**
     * @description kích hoạt trạng thái thêm câu hỏi
     * @author NTQuy
     * @param {*} state
     */
    addQuestion (state, param) {
      if (param.index !== null) {
        state.questionPreviewIndex = param.index
      }

      state.addQuestionType = param.addQuestionType
      nextTick(() => {
        param.callBack()
      })
    },

    /**
     * @description kích hoạt trạng thái copy câu hỏi
     * @author NTQuy
     * @param {*} state
     */
    copyQuestionStatus (state) {
      state.copyQuestionStatus = !state.copyQuestionStatus
    },

    /**
     * @description kích hoạt trạng thái xóa câu hỏi
     * @author NTQuy
     * @param {*} state
     */
    deleteQuestionStatus (state) {
      state.deleteQuestionStatus = !state.deleteQuestionStatus
    },

    /**
     * @author PVThang
     * @param {*} state
     * @param {*} questionType loại câu hỏi
     * @description thêm câu hỏi vào exerciseStore
     * @returns question được thêm
     */
    addAnswers (state, questionType) {
      const questionTypes = Enumeration?.QuestionTypeconst
      const answers = [] // Danh sách câu trả lời

      const answer = {
        Correct: false, // Đúng|Sai
        Content: '', // Nội dung
        Image: null, // Ảnh đính kèm
        SortOrder: 0
      }

      switch (questionType) {
        case questionTypes?.Yesorno:
          answers.push({ ...answer, Correct: true, Content: 'Đúng' })
          answers.push({ ...answer, Content: 'Sai' })
          break
        case questionTypes?.Group:
          //
          break
        case questionTypes?.Select:
          answers.push({ ...answer, Correct: true, Content: 'A' })
          answers.push({ ...answer, Content: 'B' })
          answers.push({ ...answer, Content: 'C' })
          answers.push({ ...answer, Content: 'D' })
          break
        case questionTypes?.Fill:
          answers.push({ ...answer })
          break
        case questionTypes?.Essay:
          answers.push({ ...answer })
          break
      }

      return answers
    },
    // theem 1 ds câu hỏi từ thư viện
    addListQuestion (state, questions) {
      const groupQuestions = questions.filter((question, index) => {
        question.Index = index
        return question.Type === Enumeration.QuestionType.Group
      })

      const exerciseParentQuestionIDs =
        state.exerciseStore.ParentQuestions?.map(
          (parentQuestion) => parentQuestion.SortOrder
        )
      let sortOrder = 0
      if (exerciseParentQuestionIDs?.length) {
        sortOrder = Math.max(...exerciseParentQuestionIDs)
      }

      const parentQuestions = []
      groupQuestions.reverse()?.forEach((groupQuestion) => {
        let childrenQuestions = []

        sortOrder++
        childrenQuestions = groupQuestion.ChildrenQuestions?.map((question) => {
          question.ParentID = sortOrder
          return question
        })

        questions.splice(groupQuestion.Index, 1)
        questions.splice(groupQuestion.Index, 0, ...childrenQuestions)
        groupQuestion.ParentQuestion.SortOrder = sortOrder
        parentQuestions.push(groupQuestion.ParentQuestion)
      })

      state.exerciseStore.ParentQuestions
        ? state.exerciseStore.ParentQuestions?.push(
          ...parentQuestions.reverse()
        )
        : (state.exerciseStore.ParentQuestions = [...parentQuestions.reverse()])

      const numberQuestionDefault = state.exerciseStore.Questions?.length || 0
      questions.forEach((questions, index) => {
        questions.NumberNo = numberQuestionDefault + index + 1 + ''
      })

      if (state.exerciseStore.Type === Enumeration.ExerciseType.GameGalactic) {
        questions = questions.map(question => {
          if (!question.Time) {
            question.Time = 30
          }

          return question
        })
      }

      state.exerciseStore.Questions?.length
        ? state.exerciseStore.Questions?.push(...questions)
        : (state.exerciseStore.Questions = questions)
    },

    /**
     * @author PVThang
     * @param {*} state
     * @param {*} index index của 1 question trong exerciseStore
     */
    setQuestionPreviewIndex (state, index) {
      state.questionPreviewIndex = index
    },

    setIsContentQuestion (state, param) {
      state.isContentQuestion = param
    },

    /**
     * @description Thay đổi câu hỏi preview khi dùng shortcut
     * @author NTQuy
     * @param {*} state
     * @param {*} index
     */
    keyupSetPreviewQuestion (state, index) {
      const firstPostionPreviewQuestion = document
        .getElementsByClassName('questionPreview')[0]
        .getBoundingClientRect().y
      if (state.exerciseStore?.Questions?.length > index) {
        state.questionPreviewIndex = index
      }
      nextTick(() => {
        const lastPostionPreviewQuestion = document
          .getElementsByClassName('questionPreview')[0]
          .getBoundingClientRect().y
        const rangeChangeQuestionPreview =
          lastPostionPreviewQuestion - firstPostionPreviewQuestion
        const questionsEl = document.getElementById('questions')

        if (
          lastPostionPreviewQuestion <
            document.getElementsByClassName('question')[0].offsetHeight ||
          lastPostionPreviewQuestion > questionsEl.offsetHeight
        ) {
          questionsEl.scrollTop += rangeChangeQuestionPreview
        }
      })
    },

    /**
     * @author PVThang
     * @param {*} state
     * @param {*} index index của câu hỏi bị xóa
     * @description Xóa câu hỏi trong exerciseStore
     */
    deleteQuestion (state, question) {
      const questions = state.exerciseStore?.Questions
      const questionIndex = state.exerciseStore?.Questions?.findIndex(
        (element) => element.SortOrder === question.SortOrder
      )

      let questionsFilter = []

      if (question.ChildrenQuestions?.length) {
        const parentID = question.ParentQuestion?.SortOrder
        const parentQuestions = state.exerciseStore?.ParentQuestions
        questionsFilter = questions?.filter((element) => {
          return element.ParentID !== parentID
        })
        const parentQuestionIndex = parentQuestions?.findIndex(
          (parentQuestion) => {
            return parentQuestion.SortOrder === parentID
          }
        )

        state.exerciseStore?.ParentQuestions?.splice(parentQuestionIndex, 1)
        state.exerciseStore.Questions = questionsFilter
      } else {
        state.exerciseStore.Questions.splice(questionIndex, 1)
      }
    },

    /**
     * @author PVThang
     * @param {*} state
     * @param {*} question Câu hỏi được copy
     * @description copy 1 câu hỏi vào vị trí của questionPreview
     */
    copyQuestion (state, param) {
      if (state.exerciseStore?.Questions) {
        state.exerciseStore.Questions.splice(
          state.questionPreviewIndex + 1,
          0,
          {
            ...param.newQuestion,
            Level: Enumeration.QuestionLevel?.Normal,
            Coefficient: COEFFICIENT_DEFAULT
          }
        )
        state.questionPreviewIndex++
      }
      nextTick(() => {
        param.callBack()
      })
    },

    /**
     * @author NTQuy
     * @description add data đọc từ file tải lên vào exercise store
     * @param {*} state
     * @param {*} questions
     */
    addQuestionsFromFileUpload (state, questions) {
      state.exerciseStore.Questions = questions
    },

    /**
     * Set giá trị mặc định cho addQuestionType
     * @param {*} state
     */
    setDefaultAddQuestionType (state) {
      state.addQuestionType = 0
    },

    /**
     * Thực hiện show mask
     * @param {*} state
     * @param {*} status
     */
    showMaskOnContainer (state, status) {
      state.isShowMask = status
    },

    /**
     * @description set trạng thái của các câu hỏi đang sai định dạng
     * @param {*} state
     * @param {*} errorQuestions
     */
    setErrorQuestions (state, errorQuestions) {
      state.errorQuestions = errorQuestions
    },

    /**
     * @description Đổi chỗ câu hỏi khi kéo thả đổi chỗ câu
     * @author NTQuy
     * @param {*} state
     * @param {*} params
     */
    swapQuestion (state, params) {
      const DRAG_INDEX = params.oldIndex
      const DROP_INDEX = params.newIndex
      const questions = cloneDeep(state.exerciseStore?.Questions)

      // const temp = questions[params.oldIndex]
      const questionDrag = questions[DRAG_INDEX]
      const questionDrop = questions[DROP_INDEX]

      if (!(questionDrag.ParentID && !questionDrop.ParentID)) {
        state.questionPreviewIndex = DROP_INDEX
      }

      if (!questionDrag.ParentID && !questionDrop.ParentID) {
        questions.splice(DRAG_INDEX, 1)
        questions.splice(DROP_INDEX, 0, questionDrag)
        state.exerciseStore.Questions = questions
        return
      }

      // kéo thả câu hỏi con trong cùng 1 nhóm
      if (questionDrag.ParentID && questionDrop.ParentID) {
        const childrenQuestionIndexs = []

        questions.forEach((question, index) => {
          if (question.ParentID === questionDrag.ParentID) {
            childrenQuestionIndexs.push(index)
          }
        })

        if (childrenQuestionIndexs.includes(DROP_INDEX)) {
          state.exerciseStore?.Questions?.splice(DRAG_INDEX, 1)
          state.exerciseStore?.Questions?.splice(DROP_INDEX, 0, questionDrag)
        }

        return
      }

      /// Kéo lên
      if (DRAG_INDEX > DROP_INDEX) {
        // Kéo 1 câu hỏi bình thường vào vùng câu hỏi nhóm
        if (!questionDrag.ParentID && questionDrop.ParentID) {
          const fisrChildrenIndex = questions.findIndex((question) => {
            return question.ParentID === questionDrop.ParentID
          })

          state.exerciseStore?.Questions?.splice(DRAG_INDEX, 1)
          state.exerciseStore?.Questions?.splice(
            fisrChildrenIndex,
            0,
            questionDrag
          )

          return
        }
      }

      // Kéo xuống
      if (DRAG_INDEX < DROP_INDEX) {
        // Kéo 1 câu hỏi bình thường vào vùng câu hỏi nhóm
        if (!questionDrag.ParentID && questionDrop.ParentID) {
          let lastChildrenIndex = -1

          questions.every((question, index) => {
            if (questions[index].ParentID && questions[index - 1]) {
              if (
                questions[index].ParentID === questionDrop.ParentID &&
                (!questions[index + 1]?.ParentID ||
                  questions[index + 1].ParentID !== questionDrop.ParentID)
              ) {
                lastChildrenIndex = index
                return false
              }
            }
            return true
          })

          state.exerciseStore?.Questions?.splice(
            lastChildrenIndex + 1,
            0,
            questionDrag
          )
          state.exerciseStore?.Questions?.splice(DRAG_INDEX, 1)
        }
      }

      // state.questionPreviewIndex = params.newIndex
    },

    /**
     * @description set giá trị cho câu hỏi đang được select
     * @author NTQuy
     * @param {*} state
     * @param {*} index
     */
    setSelectedQuestion (state, index) {
      const totalQuestion = state.exerciseStore?.Questions?.length

      if (index && index <= totalQuestion) {
        state.selectedQuestion = index
      }
    },

    // PBac
    // Cập nhật theme làm bài tập
    updateExerciseThemeIndex (state, exerciseThemeIndex) {
      state.exerciseThemeIndex = exerciseThemeIndex
    },
    resetSubmitExercise (state) {
      state.submitExercise = []
    },
    // Cập nhật state lưu học sinh đang làm bài dở hay không
    updateIsNotDoneExercise (state, isNotDoneExercise) {
      state.isNotDoneExercise = isNotDoneExercise
    },
    // Clone dữ liệu để giáo viên làm thử
    cloneExerciseStoreToSubmitExercise (state, exerciseStore) {
      // Kiểm tra có câu hỏi không
      if (exerciseStore.Questions?.length > 0) {
        // Chạy for each để clone dữ liệu từng câu
        exerciseStore.Questions.forEach((question) => {
          // Khởi tạo object clone
          const cloneQuestion = {
            Answers: [],
            Attachments: question.Attachments,
            Content: question.Content,
            ParentID: question?.ParentID,
            ParentQuestion: null,
            MappingAnswer: [],
            MappingAnswerColumnName: question?.MappingAnswer?.AnswerColumnName,
            Done: false,
            SortOrder: question.SortOrder,
            Type: question.Type,
            QtyCorrect: 0
          }
          // Clone dữ liệu đáp án
          question.Answers.forEach((answer) => {
            var cloneAnswer = {
              Content:
                question.Type !== Enumeration.QuestionType.Fill &&
                question.Type !== Enumeration.QuestionType.Essay
                  ? answer?.Content
                  : '',
              Correct: false,
              SortOrder: answer.SortOrder,
              Column: answer?.Column,
              Image: answer?.Image
            }

            cloneQuestion.Answers.push(cloneAnswer)
          })

          const numberCorrect = question.Answers.filter(
            (item) => item.Correct === true
          )
          if (numberCorrect?.length) {
            cloneQuestion.QtyCorrect = numberCorrect?.length
          }
          // Nếu có câu hỏi cha thì gắn thêm câu hỏi cha
          if (question.ParentID) {
            cloneQuestion.ParentQuestion = exerciseStore.ParentQuestions?.find(
              (item) => item.SortOrder === cloneQuestion.ParentID
            )
          }
          state.submitExercise.push(cloneQuestion)
        })
      }
    },
    // Cập nhật câu hỏi đang được focus
    updateIndexQuestion (state, indexQuestion) {
      state.indexQuestion = indexQuestion
    },

    // cập nhật câu trả lời cho câu hỏi
    updateAnswerForQuestion (state, param) {
      const tmpSubmit = state.submitExercise?.filter(
        (item) => item.SortOrder === param.sortOrderQuestion
      )

      // Đối với dạng câu hỏi Yes/No
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Yesorno) {
        tmpSubmit[0].Answers.forEach(function (item) {
          if (item.SortOrder === param.sortOrderAnswer) {
            item.Correct = !item.Correct
          } else {
            item.Correct = false
          }
        })
      }

      // Đối với dạng câu hỏi chọn nhiều đáp án
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Select) {
        tmpSubmit[0].Answers.forEach(function (item) {
          if (item.SortOrder === param.sortOrderAnswer) {
            item.Correct = !item.Correct
          }
        })
      }

      // Đối với dạng câu hỏi điền từ vào chỗ trống
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Fill) {
        tmpSubmit[0].Answers.forEach(function (item) {
          if (item.SortOrder === param.sortOrderAnswer) {
            item.Content = param.contentAnswer
            if (param.contentAnswer !== '') {
              item.Correct = true
            } else {
              item.Correct = false
            }
          }
          if (item.Correct === true) {
            tmpSubmit[0].Done = true
          }
        })
      }

      // Đối với dạng câu hỏi tự luận
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Essay) {
        tmpSubmit[0].Answers.forEach(function (item) {
          if (item.SortOrder === param.sortOrderAnswer) {
            item.Content = param.contentAnswer
            item.AnswerAttachment = param.attachItems
            if (param.contentAnswer !== '' || param.attachItems?.length > 0) {
              item.Correct = true
            } else {
              item.Correct = false
            }
          }
        })
      }
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Pairing) {
        tmpSubmit[0].MappingAnswer = param.correctAnswer
        if (tmpSubmit[0].MappingAnswer.length) {
          tmpSubmit[0].Done = true
          tmpSubmit[0].Answers.map((answer) => {
            answer.Correct = true
            return answer
          })
        } else {
          tmpSubmit[0].Answers.map((answer) => {
            answer.Correct = false
            return answer
          })
        }
      }
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Pairing) {
        return
      }
      tmpSubmit[0].Done = false
      // Set lại trạng thái câu hỏi đã được trả lời hay chưa
      tmpSubmit[0].Answers.forEach(function (item) {
        if (item.Correct === true) {
          tmpSubmit[0].Done = true
        }
      })
    }
  },

  actions: {
    /**
     * @author PVThang
     * @param {*} context
     * @returns 1 object câu hỏi mặc đinh
     */
    createNewQuestion (context, autoFillContent = false) {
      const question = {
        Type: 0, // Loại câu hỏi
        Content: '', // Nội dung câu hỏi
        Attachments: [], // Đính kèm
        Owner: null, // Người sở hữu
        Hint: '', // Gọi ý
        Answers: [], // Danh sách câu trả lời
        SortOrder: 0,
        Level: Enumeration.QuestionLevel?.Normal,
        Coefficient: COEFFICIENT_DEFAULT
      }
      const answer = {
        Correct: false, // Đúng|Sai
        Content: '', // Nội dung
        Image: null, // Ảnh đính kèm
        SortOrder: 0
      }

      for (let i = 0; i < NumberAnswerDefault; ++i) {
        const newAnswer = { ...answer }

        if (autoFillContent) {
          newAnswer.Content = String.fromCharCode(AssciCode.Upper[0] + i)
        }
        question.Answers.push(newAnswer)
      }

      return question
    },

    /**
     * @author PVThang
     * @param {*} context
     * @description Tạo 1 câu đáp án mới
     */
    createNewAnswer (context) {
      return {
        Correct: false, // Đúng|Sai
        Content: '', // Nội dung
        Image: null, // Ảnh đính kèm
        SortOrder: 0
      }
    },

    /**
     * @author PVThang
     * @param {*} context
     * @param {*} exerciseStore
     * @description Thêm học liệu
     */
    async insertExerciseStore (context, exerciseStore) {
      return await ExerciseStoreAPI.postAsync('', exerciseStore)
    },

    /**
     * @author PVThang
     * @param {*} context
     * @param {*} exerciseStore
     * @description update ExrciseStore
     */
    async updateExerciseStore (context, exerciseStore) {
      return await ExerciseStoreAPI.updateExerciseStore(
        exerciseStore?.Id,
        exerciseStore
      )
    },

    /**
     * @author PVThang
     * @param {*} context
     * @param {*} exerciseStore
     * @returns
     * @description thêm mới hoặc sửa
     */
    async upsertExercise (context, exerciseStore) {
      exerciseStore.Questions = exerciseStore.Questions?.map((question) => {
        delete question.CreatedDate
        delete question.ModifiedDate
        question.Answers = question.Answers?.map((answer) => {
          delete answer.CreatedDate

          delete answer.ModifiedDate

          return answer
        })
        return question
      })

      exerciseStore.QtyQuestion = exerciseStore?.Questions?.length
      const exerciseFormat = handleBeforeSave(exerciseStore)
      const listGiftCards = sessionStorage.get(
        sessionStorageKeys.TEACHER_GIFT_CARD
      )
      // Giảm số lượt sử dụng trên session
      if (exerciseStore.Status === Enumeration.ExerciseStatus?.Complete) {
        const index = listGiftCards?.findIndex(
          (element) =>
            element.GiftCardType ===
            Enumeration.GiftCardType.ComposeExerciseStore
        )
        listGiftCards[index].UsedCount++
        sessionStorage.set(sessionStorageKeys.TEACHER_GIFT_CARD, listGiftCards)
      }
      return await ExerciseStoreAPI.postAsync('upsert', exerciseFormat)
    },

    /**
     * @author PVThang
     * @param {*} context
     * @param {*} id
     * @description Lấy exerciseStore theo ID
     */
    getExerciseStore (context, id) {
      return new Promise((resolve, reject) => {
        MISAStoreAPI.getAsync(`detail?id=${id}`)
          .then((res) => {
            if (res?.IsSuccess) {
              context.commit('setExerciseStore', res.Data || {})

              const exerciseStore = res.Data
              const exerciseStoreHandle = handleMappingAnswer(
                exerciseStore,
                Enumeration.HandlePairingAnswerType.Revert
              )

              context.commit('setExerciseStore', exerciseStoreHandle || {})
              resolve(true)
            } else {
              reject(res)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * lấy dữ liệu học liệu theo ID
     * @param {*} context
     * @param {*} params
     */
    getExerciseDetailByID (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync('/exercise-detail-public', { params: params })
          .then((res) => {
            const exercise = handleMappingAnswer(
              res.Data,
              Enumeration.HandlePairingAnswerType.Revert
            )
            context.commit('setExerciseStore', exercise)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * lấy dữ liệu học liệu theo ID
     * @param {*} context
     * @param {*} exerciseStore
     * @returns
     */
    getByIdExerciseStore (context, exerciseStore) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync(`/${exerciseStore}`)
          .then((res) => {
            const exercise = handleMappingAnswer(
              res.Data,
              Enumeration.HandlePairingAnswerType.Revert
            )
            context.commit('setExerciseStore', exercise)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author PVThang
     * @description extract file
     * @param {*} context
     * @param {*} param
     * @returns
     */
    async extractFile (context, param) {
      return await FileAPI.postAsync('scanner/extraction', param)
    },

    /**
     * @author PVThang
     * @description extract file thành ảnh
     * @param {*} context
     * @param {*} param
     * @returns
     */
    async extractFileToImage (context, param) {
      return await FileAPI.postAsync('scanner/extraction-image', param)
    },

    /**
     * @author PBac
     * @description Lấy dữ liệu từ ExerciseStore và clone dữ liệu để giáo viên làm thử
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getExerciseAndClone (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync(`${params.id}`)
          .then((res) => {
            if (res?.IsSuccess) {
              const exercise = handleMappingAnswer(
                res.Data,
                Enumeration.HandlePairingAnswerType.Revert
              )
              context.commit('resetSubmitExercise')
              context.commit('setExerciseStore', exercise || {})
              context.commit('cloneExerciseStoreToSubmitExercise', exercise)
              context.commit('updateIndexQuestion', 0)
              resolve(true)
            } else {
              reject(res)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách câu hỏi của học liệu
     * @param {*} param0
     * @param {*} exerciseStoreID
     * @returns
     */
    getQuestionByExerciseStoreID ({ commit }, exerciseStoreID) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync('filter/questions/' + exerciseStoreID)
          .then((res) => {
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
